import type { StorageInterface } from './storage.interface'

export class LocalStorageRepository implements StorageInterface {
  set(key: string, value: string): void {
    localStorage.setItem(key, value)
  }

  get(key: string): string | null {
    return localStorage.getItem(key)
  }

  remove(key: string): void {
    localStorage.removeItem(key)
  }

  clear(): void {
    localStorage.clear()
  }
}
